// extracted by mini-css-extract-plugin
export default {"root":"VerificationBadge_root__FhJT9","root--success":"VerificationBadge_root--success__-GPBA","root--warning":"VerificationBadge_root--warning__FiCtA"};